import { render, staticRenderFns } from "./FantasyPreference.vue?vue&type=template&id=1c8e65b7&"
import script from "./FantasyPreference.vue?vue&type=script&lang=js&"
export * from "./FantasyPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports